import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthenticateService } from './authenticate.service';
import { Router } from '@angular/router';

// @Injectable()
// export class CustomAuthInterceptor implements HttpInterceptor {
//     constructor(private authenticationService: AuthenticateService) { }
//     intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//         const tokenInfo = this.authenticationService.getSessionToken;
//         if (tokenInfo && tokenInfo.access_token) {
//             request = request.clone({
//                 setHeaders: { 
//                     Authorization: `${tokenInfo.token_type} ${tokenInfo.access_token}`
//                 }
//             });
//         }
//         return next.handle(request);
//     }    
// }

@Injectable()
export class CustomAuthInterceptor implements HttpInterceptor {
    constructor(private router: Router) { }
   
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
            this.router.navigate(['/accessdenied']);
        }
        return throwError(error);
      })
    );
  }
}